"use strict";

exports.__esModule = true;
exports.TransformConstraintData = void 0;

var _ConstraintData2 = require("./ConstraintData");

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/** Stores the setup pose for a {@link TransformConstraint}.
 *
 * See [Transform constraints](http://esotericsoftware.com/spine-transform-constraints) in the Spine User Guide. */
var TransformConstraintData = /*#__PURE__*/function (_ConstraintData) {
  _inheritsLoose(TransformConstraintData, _ConstraintData);

  function TransformConstraintData(name) {
    var _this;

    _this = _ConstraintData.call(this, name, 0, false) || this;
    /** The bones that will be modified by this transform constraint. */

    _this.bones = new Array();
    /** The target bone whose world transform will be copied to the constrained bones. */

    _this.target = null;
    _this.mixRotate = 0;
    _this.mixX = 0;
    _this.mixY = 0;
    _this.mixScaleX = 0;
    _this.mixScaleY = 0;
    _this.mixShearY = 0;
    /** An offset added to the constrained bone rotation. */

    _this.offsetRotation = 0;
    /** An offset added to the constrained bone X translation. */

    _this.offsetX = 0;
    /** An offset added to the constrained bone Y translation. */

    _this.offsetY = 0;
    /** An offset added to the constrained bone scaleX. */

    _this.offsetScaleX = 0;
    /** An offset added to the constrained bone scaleY. */

    _this.offsetScaleY = 0;
    /** An offset added to the constrained bone shearY. */

    _this.offsetShearY = 0;
    _this.relative = false;
    _this.local = false;
    return _this;
  }

  return TransformConstraintData;
}(_ConstraintData2.ConstraintData);

exports.TransformConstraintData = TransformConstraintData;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7QUE2QkE7Ozs7OztBQUdBOzs7SUFHYUEsdUI7OztFQW9DWixpQ0FBYUMsSUFBYixFQUF5QjtJQUFBOztJQUN4QixtQ0FBTUEsSUFBTixFQUFZLENBQVosRUFBZSxLQUFmO0lBbkNEOztJQUNBLGNBQVEsSUFBSUMsS0FBSixFQUFSO0lBRUE7O0lBQ0EsZUFBbUIsSUFBbkI7SUFFQSxrQkFBWSxDQUFaO0lBQ0EsYUFBTyxDQUFQO0lBQ0EsYUFBTyxDQUFQO0lBQ0Esa0JBQVksQ0FBWjtJQUNBLGtCQUFZLENBQVo7SUFDQSxrQkFBWSxDQUFaO0lBRUE7O0lBQ0EsdUJBQWlCLENBQWpCO0lBRUE7O0lBQ0EsZ0JBQVUsQ0FBVjtJQUVBOztJQUNBLGdCQUFVLENBQVY7SUFFQTs7SUFDQSxxQkFBZSxDQUFmO0lBRUE7O0lBQ0EscUJBQWUsQ0FBZjtJQUVBOztJQUNBLHFCQUFlLENBQWY7SUFFQSxpQkFBVyxLQUFYO0lBQ0EsY0FBUSxLQUFSO0lBRXlCO0VBRXhCOzs7RUF0QzJDQywrQiIsIm5hbWVzIjpbIlRyYW5zZm9ybUNvbnN0cmFpbnREYXRhIiwibmFtZSIsIkFycmF5IiwiQ29uc3RyYWludERhdGEiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL1RyYW5zZm9ybUNvbnN0cmFpbnREYXRhLnRzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19